import { z } from "zod";
import { INTEREST_RATINGS, VIDEO_MILESTONES } from "../constants/index";
import { email, nonEmpty, uuid } from "./_primitives";

export const identifyViewerSchema = z.object({
  name: nonEmpty.max(200),
  email,
  company: z.string().trim().max(200).optional(),
});

export const signNdaSchema = z.object({
  signatureName: nonEmpty.max(200),
  accepted: z.literal(true),
});

export const rateTopicSchema = z.object({
  videoRef: uuid,
  rating: z.enum(INTEREST_RATINGS),
});

export const setRatingsSchema = z.object({
  ratings: z.array(rateTopicSchema),
});

export const milestoneSchema = z.object({
  videoRef: uuid,
  milestone: z.union([
    z.literal(VIDEO_MILESTONES[0]),
    z.literal(VIDEO_MILESTONES[1]),
    z.literal(VIDEO_MILESTONES[2]),
    z.literal(VIDEO_MILESTONES[3]),
  ]),
  watchDurationSeconds: z.number().int().nonnegative(),
});

export const heartbeatSchema = z.object({
  videoRef: uuid,
  watchDurationSeconds: z.number().int().nonnegative(),
  completionPercentage: z.number().int().min(0).max(100),
});

export const rewatchSchema = z.object({
  videoRef: uuid,
});

export const forwardSchema = z.object({
  name: nonEmpty.max(200),
  email,
});

export type IdentifyViewerInput = z.infer<typeof identifyViewerSchema>;
export type SignNdaInput = z.infer<typeof signNdaSchema>;
export type RateTopicInput = z.infer<typeof rateTopicSchema>;
export type SetRatingsInput = z.infer<typeof setRatingsSchema>;
export type MilestoneInput = z.infer<typeof milestoneSchema>;
export type HeartbeatInput = z.infer<typeof heartbeatSchema>;
export type RewatchInput = z.infer<typeof rewatchSchema>;
export type ForwardInput = z.infer<typeof forwardSchema>;
